import { FilterOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import FilterContent, {
  TFilterContent,
} from 'components/rest/Filter/FilterContent';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function TFilterButton({
  content,
  filters,
  filterData,
}: TFilterContent) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <Popover
      open={open}
      onOpenChange={()=>setOpen(true)}
      trigger="click"
      placement="bottom"
      content={
        <FilterContent
          setOpen={setOpen}
          content={content}
          filterData={filterData}
          filters={filters}
        />
      }
    >
      <Button size="large" icon={<FilterOutlined />} className='text-sm'>{t('button.filter')}</Button>
    </Popover>
  );
}
